import { ClientsConsolePage } from "../../operator/console/clients-console";

export default function ConsoleClientsRoute() {
  return <ClientsConsolePage />;
}
